<div class="modal-header reserve-inputs-header">
  <h5 class="modal-title">Reserve Inputs</h5>
  <div class="header-actions">
    <button
      type="button"
      class="close-btn"
      (click)="closeModal()"
      title="Close"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>
  </div>
</div>
<div class="modal-body reserve-inputs-body">
  <div class="reserve-inputs-content">
    <div class="form_input">
      <label class="control-label reserve-inputs-label" for="reserved_for">
        <span class="required">*</span> Reserved For:
      </label>
      <div class="reserve-inputs-field-group customer-field-group">
        <ng-select [items]="accountingService.customers" bindLabel="contact.display_name" bindValue="id"
          [multiple]="false" [closeOnSelect]="true" appendTo="body" class="form-control text-uppercase input modern-input joined-select"
          id="customer" [placeholder]="customer_placeholder" [(ngModel)]="reserve_inputs.reserved_for"
          (change)="customerSelected()">
          <ng-template ng-option-tmp let-item="item">
            <div [title]="item.contact.display_name">
              {{ item.contact.display_name }}
              <br>
              <span style="font-size: smaller; color: gray;">
                {{ item.contact.phone_number ? formatPhoneNumber(item.contact.phone_number) : '' }}
                {{ item.contact.email ? ' | ' + item.contact.email : '' }}
              </span>
            </div>
          </ng-template>
        </ng-select>
        <div class="button-between">
        @if (!this.reserve_inputs.reserved_for) {
        <button type="button" class="btn btn-primary btn-sm add-button" (click)="addNewCustomer()"
          tooltip="Add Customer">
          <i class="fa-solid fa-plus"></i>
        </button>
        }
        @if (this.reserve_inputs.reserved_for) {
        <button type="button" class="btn btn-warning btn-sm edit-button" (click)="editCustomer()"
          tooltip="Edit Customer">
          <i class="fa-solid fa-pen-to-square"></i>
        </button>
        }
        </div>
      </div>
    </div>
    <div class="form_input">
      <label class="control-label reserve-inputs-label notes-label" for="notes">Notes:
      </label>
      <div class="reserve-inputs-field-group">
        <input #notes [(ngModel)]="reserve_inputs.reserve_notes" type="text-area" class="form-control note-input modern-input" />
      </div>
    </div>
    <div class="reserve-inputs-actions">
      <div class="required-indicator">
        <span class="text-danger">*</span>
        <span> denotes required fields</span>
      </div>
      <button class="btn btn-primary reserve-submit-btn" (click)="submit()"
        [disabled]="!reserve_inputs.reserved_for">
        Submit
      </button>
    </div>
  </div>
</div>